// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
// From Marty documentation
// (http://martyjs.org/guides/application/automatic-registration.html)

import warnings from 'marty-lib/modules/core/warnings'
warnings.parseJSONDeprecated = false

// "It's easy to forget to register a type in the application after you create
// it. Fortunately if you're using webpack or browserify we can automate the
// registration process."
let SINGLETON_APPLICATION = false

const context = require.context('../', true, /^\.\/(actions|queries|sources|stores)/)

const Application = Marty.createApplication(function() {
  _.each(context.keys(), key => {
    let id
    if (/\.js/.test(key)) {
      id = key.slice(0, -'.js'.length).replace('./', '').replace(/\//g, '.')
      this.register(id, context(key).default)
    }

    if (/\.coffee/.test(key)) {
      id = key.slice(0, -'.coffee'.length).replace('./', '').replace(/\//g, '.')
      return this.register(id, context(key))
    }
  })

  return SINGLETON_APPLICATION = this
})

const getApplication = () => SINGLETON_APPLICATION

export { Application, getApplication }



// WEBPACK FOOTER //
// ./src/scripts/app/Application.js